import {
  computedFillInBlankSumScore,
  getSubQuestions,
} from '@/features/test-paper/components/Blocks/Question/EditQuestion/utils'
import { questionTypeToLabel } from '@/features/test-paper/utils'
import { getTheme } from '@/utils/theme'
import { InputNumber } from 'antd'
import {
  PaperBlock,
  PaperBlockReq,
  PaperQuestion,
  QuestionTypeEnum,
} from 'packages/sdks-next/growp'
import React, { useContext } from 'react'
import styled from 'styled-components'
import { ProductFillScoreSetting } from './ProductFillScoreSetting'
import { editQuestion } from '../../utils'
import { findIndex } from '@seiue/util'
import { useAtom } from 'jotai'
import { focusedBlockAtom } from '@/features/test-paper/components/BlockList/atoms'
import { BlockStateEnum } from 'packages/feature-utils/test-paper'
import { precisionFormat } from 'packages/utils'
import { EditPaperContext } from '../../context'

export const ProductScoreSetting: React.FC<{
  block: PaperBlock
  serialNumber: number
  mainQuestion: PaperQuestion
  onUpdateScore: (blockId: number, payload: PaperBlockReq) => void
}> = ({ block, serialNumber, mainQuestion, onUpdateScore }) => {
  const { limitLevel } = useContext(EditPaperContext)
  const [focusedBlock, setFocusedBlock] = useAtom(focusedBlockAtom)
  const theme = getTheme()
  const firstLevelSubQuestions = getSubQuestions(
    block.questions || [],
    mainQuestion.id
  )
  return (
    <>
      <Wrapper>
        <div
          style={{
            color: theme.text._1,
          }}
        >
          {serialNumber}复合
        </div>
        <div style={{ width: '85px', textAlign: 'right' }}>
          {precisionFormat(mainQuestion.score)}分
        </div>
      </Wrapper>
      {firstLevelSubQuestions.map((question, index) => {
        return question.type === QuestionTypeEnum.FillInBlank ? (
          <ProductFillScoreSetting
            index={index}
            firstLevelSubQuestion={question}
            block={block}
            onUpdateScore={onUpdateScore}
            key={index}
            mainQuestion={mainQuestion}
          />
        ) : (
          <Wrapper key={index}>
            <LabelWrapper>
              <LIcon />
              <div>
                ({index + 1}){questionTypeToLabel.get(question.type)}
              </div>
            </LabelWrapper>
            <InputNumber
              disabled={
                limitLevel > 1 || focusedBlock.state === BlockStateEnum.Editing
              }
              onFocus={() => {
                const ele = document.getElementById(`${block.id}`)
                if (ele) {
                  setFocusedBlock({
                    id: block.id,
                    state: BlockStateEnum.Selected,
                  })
                  ele.scrollIntoView({ block: 'center', behavior: 'smooth' })
                }
              }}
              stringMode={true}
              value={precisionFormat(question.score)}
              onChange={(e) => {
                const v = precisionFormat(e)
                const newQuestions = editQuestion(
                  block.questions || [],
                  question.id,
                  {
                    score: v ? String(v) : undefined,
                  }
                )
                const i = findIndex(
                  newQuestions,
                  (q) => q.id === question.parentId
                )
                newQuestions.splice(i, 1, {
                  ...mainQuestion,
                  score: String(
                    computedFillInBlankSumScore(
                      getSubQuestions(newQuestions, mainQuestion.id)
                    )
                  ),
                })
                onUpdateScore(block.id, {
                  ...block,
                  questions: newQuestions,
                })
              }}
            />
          </Wrapper>
        )
      })}
    </>
  )
}

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  & > div {
    font-size: 14px;
    color: ${(props) => props.theme.text._1};
  }
`

const LabelWrapper = styled.div`
  width: 95px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
`

const LIcon = styled.div`
  width: 6px;
  height: 6px;
  margin-right: 4px;
  border-left: 1px solid #afbdc7;
  border-bottom: 1px solid #afbdc7;
`
